import { Injectable } from '@angular/core';
import { HttpInterceptorService } from '../../core/services/http-interceptor.service';


@Injectable()
export class EnumService {
    private baseUrl = '/valueset';
  constructor(
    private _http: HttpInterceptorService,
  ) {
  }

  public getRaces() {
    return this._http.get(this.baseUrl + '/getRace');
  }
  public getEthnicities() {
    return this._http.get(this.baseUrl + '/getEthnicity');
  }
  public getCountries() {
    return this._http.get(this.baseUrl + '/getCountries');
  }
  public getOrganizationTypes() {
    return this._http.get(this.baseUrl + '/getOrganizationTypes');
  }
  public getNof1Profiles() {
    return this._http.get(`${this.baseUrl}/NOF1Profiles`);
  }
  public getPractitionerRoles(managingOrganization: any) {
    return this._http.get('/roles/' + managingOrganization);
  }
  public getPractitionerSpecialties() {
    return this._http.get(this.baseUrl + '/getPractitionerSpecialties');
  }
  public getPractitionerQualifications() {
    return this._http.get(this.baseUrl + '/getPractitionerQualifications');
  }
  public getSpecimenTypes() {
    return this._http.get(this.baseUrl + '/getSpecimenTypes');
  }
  public getTumorGrades() {
    return this._http.get(this.baseUrl + '/Tumor-Grade');
  }
  public getTumorStages() {
    return this._http.get(this.baseUrl + '/intelliome-tumor-staging');
  }
  public getSpecimenCollections() {
    return this._http.get(this.baseUrl + '/intelliome-specimen-collection');
  }
  public getTreatementStatuses() {
    return this._http.get(this.baseUrl + '/getTreatmentStatuses');
  }
  public getTopology(searchVal: any) {
    const params = { searchValue: searchVal };
    return this._http.get('/ValuesetFlattenAndFilter/ICDO3TopologyCodes', params);
  }
  public getDiagnosisTypes(searchVal: any) {
    const params = { searchValue: searchVal };
    return this._http.get('/ValuesetFlattenAndFilter/ICD10NeoplasmsCodes', params);
  }
  public getHistopathologies(searchVal: any) {
    const params = { searchValue: searchVal };
    return this._http.get('/ValuesetFlattenAndFilter/ICDO3MorphologyCodes', params);
  }
  public getIHCStatuses() {
    return this._http.get(this.baseUrl + '/getIHCStatuses');
  }
  public getPrinters() {
    return this._http.get(this.baseUrl + '/getPrinters');
  }
}
